// src/data/comedians/steve-martin.js

const base = {
  id: 'steve-martin',
  slug: 'steve-martin',
  name: 'Steve Martin',
  birthYear: 1945,
  image: require('@/assets/images/img_Steve_Martin.jpeg'),
  famousWorks: [
    'The Jerk (1979)',
    'The Man with Two Brains (1983)',
    'Planes, Trains & Automobiles (1987)',
    'Roxanne (1987)',
    'Father of the Bride series',
    'Bowfinger (1999)',
    "Let's Get Small (album)",
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Wild and crazy guy turned Renaissance man',
    bio: `Steve Martin is an American actor, comedian, writer, producer, and musician whose career spans over five decades. He is one of the most successful and influential comedians in American entertainment, known for his absurdist comedy and later his work as a serious actor and author.\n\nBorn in Waco, Texas, Martin began his career writing for television variety shows before developing his stand-up act in the 1970s, becoming famous for his absurdist comedy, props like the arrow-through-the-head, and his "wild and crazy guy" persona.\n\nMartin transitioned to film with "The Jerk" and became a major movie star. He has written bestselling books and plays, and is an accomplished banjo player who has won Grammy Awards for bluegrass music — a true Renaissance man of entertainment.`,
    style: 'Absurdist, prop comedy, intellectual humor, self-deprecating',
    achievements: [
      'Emmy Awards',
      'Grammy Awards (multiple, including bluegrass)',
      'Mark Twain Prize for American Humor (2005)',
      'Kennedy Center Honors (2007)',
      'Honorary Academy Award (2013)',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Du type "fou et dingue" à l\'homme de la Renaissance',
    bio: `Steve Martin est un acteur, comédien, écrivain, producteur et musicien américain dont la carrière s'étend sur plus de cinq décennies. Il est l'un des comédiens les plus influents du divertissement américain, connu pour sa comédie absurde.\n\nNé à Waco au Texas, Martin débuta sa carrière en écrivant pour des émissions de variétés à la télévision, avant de développer son stand-up dans les années 1970, célèbre pour ses accessoires comiques et son personnage de "gars fou et dingue".\n\nIl se tourna ensuite vers le cinéma avec "The Jerk". Il a écrit des livres et des pièces de théâtre à succès, et est un joueur de banjo accompli ayant remporté des Grammy Awards pour la musique bluegrass — un vrai homme de la Renaissance.`,
    style: 'Absurde, comédie d\'accessoires, humour intellectuel, autodérision',
    achievements: [
      'Emmy Awards',
      'Grammy Awards (multiples, dont bluegrass)',
      'Mark Twain Prize for American Humor (2005)',
      'Kennedy Center Honors (2007)',
      'Oscar honorifique (2013)',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Del tipo "loco y alocado" al hombre del Renacimiento',
    bio: `Steve Martin es un actor, comediante, escritor, productor y músico estadounidense cuya carrera abarca más de cinco décadas. Es uno de los comediantes más exitosos e influyentes del entretenimiento americano, conocido por su comedia absurdista.\n\nNacido en Waco, Texas, Martin comenzó su carrera escribiendo para programas de variedades en televisión antes de desarrollar su stand-up en los años 70, famoso por sus accesorios cómicos y su personaje de "tipo loco y alocado".\n\nDespués pasó al cine con "The Jerk". Ha escrito libros y obras de teatro exitosas, y es un habilidoso tocador de banjo que ha ganado Grammy Awards por música bluegrass — un auténtico hombre del Renacimiento.`,
    style: 'Absurdista, comedia con accesorios, humor intelectual, autodespreciativo',
    achievements: [
      'Emmy Awards',
      'Grammy Awards (múltiples, incluyendo bluegrass)',
      'Mark Twain Prize for American Humor (2005)',
      'Kennedy Center Honors (2007)',
      'Oscar Honorífico (2013)',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'من "الرجل المجنون" إلى رجل النهضة الفنية',
    bio: `ستيف مارتن ممثل وكوميدي وكاتب ومنتج وموسيقي أمريكي تمتد مسيرته لأكثر من خمسة عقود. يُعدّ من أنجح الكوميديين وأكثرهم تأثيرًا في الترفيه الأمريكي، ويشتهر بكوميديا العبث.\n\nوُلد في واكو بتكساس، وبدأ مسيرته بالكتابة لبرامج الترفيه التلفزيونية قبل أن يطوّر عروضه الستاند أب في السبعينيات، مشتهرًا بالمؤثرات الكوميدية وشخصية "الرجل المجنون والمبهج".\n\nانتقل بعدها إلى السينما مع فيلم "The Jerk"، وكتب كتبًا ومسرحيات ناجحة. كما يُعدّ عازف بانجو بارعًا فاز بجوائز Grammy في موسيقى البلوغراس — إنه حقًّا رجل نهضة فنية متكاملة.`,
    style: 'فكاهة عبثية، كوميديا بالأدوات، فكاهة فكرية، استهزاء بالنفس',
    achievements: [
      'جوائز Emmy',
      'جوائز Grammy متعددة (تشمل البلوغراس)',
      'جائزة مارك توين للفكاهة الأمريكية (2005)',
      'Kennedy Center Honors (2007)',
      'جائزة الأوسكار الفخرية (2013)',
    ],
  },
];
